export default "__VITE_ASSET__ClfGgcEM__"